import { render } from "./FileIconPreview.vue?vue&type=template&id=5727a7f9"
import script from "./FileIconPreview.vue?vue&type=script&lang=js"
export * from "./FileIconPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__